import { useState } from 'react';
import PropTypes from 'prop-types';

import Header from 'uI/Header/Header';
import LateralMenu from 'uI/LateralMenu/LateralMenu';

import classes from './Layout.module.css';

const Layout = props => {
  const [selectedItem, setSelecteditem] = useState('');
  console.log(
    '🚀 ~ file: Layout.js:11 ~ Layout ~ selectedItem:',
    selectedItem
  );
  const changeSelectedItemHandler = itemSelected => {
    setSelecteditem(itemSelected);
  };

  return (
    <main className={classes.mainContainer}>
      <Header />
      <LateralMenu changeSelectedItem={changeSelectedItemHandler} />
      <section className={classes.sectionContainer}>
        <div className={classes.pageContainer}>{props.children}</div>
      </section>
    </main>
  );
};

Layout.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: PropTypes.data
};

export default Layout;
